import { Modal } from "antd"
import React from "react"

export default  ({handleOk = ()=>{}, handleCancel = ()=>{}, contents="", type="info"})=>{

    Modal[type]({
        title:contents,
        onOk:handleOk,
        onCancel:handleCancel,
        icon : ""
    })
}